import ReactDOM from "react-dom/client";
import App from "./_app/App";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { ToastProvider } from "./_context/ToastContext/ToastContext";
import RouteFallback from "./_components/loaders/RouteFallback";
// Table cell/renderer styles are used by nearly every list page. They load here, in the app shell,
// so webpack does not order them differently in different lazy route chunks (that ordering
// conflict fails a CI=true build). Cells before renderers, which builds on them.
import "./_components/ui/Table/_table-cells.scss";
import "./_components/ui/Table/_table-renderers.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ToastProvider>
    <Provider store={store}>
      <PersistGate loading={<RouteFallback />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ToastProvider>
);
